import React from "react";
import { Menu, MenuList, MenuItem, MenuPopover } from "@fluentui/react-components";
import type { MenuProps } from "@fluentui/react-components";
import { observer } from "owa-mobx-react";
import { ribbonCustomize } from "./RibbonCustomizerContextMenu.locstring.json";
import loc from "owa-localize";

export const RibbonCustomizerContextMenu: React.FC<{
    anchorX: number;
    anchorY: number;
    onCustomizeClick: () => void;
    onDismiss: () => void;
}> = observer(props => {
    const { anchorX, anchorY, onCustomizeClick, onDismiss } = props;
    
    const positioning: MenuProps["positioning"] = React.useMemo(() => ({
        align: "top",
        autoSize: "height",
        position: "after",
        target: {
            getBoundingClientRect: () => ({
                bottom: anchorY + 1,
                height: 1,
                left: anchorX,
                right: anchorX + 1,
                toJSON() {
                    return this;
                },
                top: anchorY,
                width: 1,
                x: anchorX,
                y: anchorY,
            }),
        },
    }), [anchorX, anchorY]);
    
    return (<Menu positioning={positioning} open={true} onOpenChange={onDismiss} closeOnScroll={true}>
            <MenuPopover>
                <MenuList>
                    <MenuItem onClick={onCustomizeClick}>{loc(ribbonCustomize)}</MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>);
}, "RibbonCustomizerContextMenu");
